const storeName = 'user';
export default {
    SET_PROFILE: `${storeName}.SET_PROFILE`,
    SET_PROFILE_DONE: `${storeName}.SET_PROFILE_DONE`,
    SET_WARNING_MESSAGE: `${storeName}.SET_WARNING_MESSAGE`,
    SET_CHILDREN: `${storeName}.SET_CHILDREN`,
    LOAD_PROFILE: `${storeName}.LOAD_PROFILE`,
    SET_BABYBORN: `${storeName}.SET_BABYBORN`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    ACCEPT_PRIVACY_POLICY: `${storeName}.ACCEPT_PRIVACY_POLICY`,
    SET_STATUS_DELAY: `${storeName}.SET_STATUS_DELAY`,
    SET_STATUS_RETRY: `${storeName}.SET_STATUS_RETRY`,
    SET_LOYALTY_CARD: `${storeName}.SET_LOYALTY_CARD`,
    SET_STATUS_BEFORE_ATTEMPT_DELAY: `${storeName}.SET_STATUS_BEFORE_ATTEMPT_DELAY`,
    SET_PENDING_SUBSCRIPTION: `${storeName}.SET_PENDING_SUBSCRIPTION`,
    SET_REGISTERED_ON_CHECKOUT: `${storeName}.SET_REGISTERED_ON_CHECKOUT`,
    DISMISS_BIRTH_DATE_POPUP: `${storeName}.DISMISS_BIRTH_DATE_POPUP`,
    SET_USER_POPOVER_INFO: `${storeName}.SET_USER_POPOVER_INFO`,
    GET_LOYALTY_CHEQUES: `${storeName}.GET_LOYALTY_CHEQUES`,
    LOAD_LOYALTY_CHEQUES: `${storeName}.LOAD_LOYALTY_CHEQUES`,
    SET_LOYALTY_CHEQUE_ERROR: `${storeName}.SET_LOYALTY_CHEQUE_ERROR`,
    CHECK_LOGGED_STATUS: `${storeName}.CHECK_LOGGED_STATUS`,
    CLEAR_LAST_VIEWED_PRODUCTS: `${storeName}.CLEAR_LAST_VIEWED_PRODUCTS`,
    SET_LAST_VIEWED_PRODUCTS_CLEARED: `${storeName}.SET_LAST_VIEWED_PRODUCTS_CLEARED`,
    SET_AUSTRIA: `${storeName}.SET_AUSTRIA`,
    SET_GERMANY: `${storeName}.SET_GERMANY`,
    ENABLE_FOR_NON_VERIFIED_USER: `${storeName}.ENABLE_FOR_NON_VERIFIED_USER`,
    DISABLE_LOYALTY_VOUCHER: `${storeName}.DISABLE_LOYALTY_VOUCHER`,
    UPDATE_PROFILE: `${storeName}.UPDATE_PROFILE`,
};
